import type { WidgetRenderContext } from "@salestrak/ui";

import { FollowUpCaption } from "#app/components/follow-ups/follow-up-section";
import { useProjectClock } from "#app/components/updates/project-update-widget";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";
import type { IssueUpdatesConfig } from "./index";

/** The folded section's one fact: the Next row's string, in its color, at the
 *  header's trailing edge — so a collapsed Follow up still says when the next
 *  Update is owed. Open, the row says it and the header stays quiet. Off
 *  captions nothing: the header is the Start Follow up row then. */
export function IssueUpdatesHeaderCaption({ collapsed }: WidgetRenderContext<IssueUpdatesConfig>) {
  const ctx = useIssueWidgetContext();
  const { stageMap, workflowMap } = useWorkspaceData();
  const issue = ctx.issue;
  const stage = ctx.stage ?? (issue ? stageMap.get(issue.stageId) : undefined) ?? null;
  const workflow = ctx.workflowId ? workflowMap.get(ctx.workflowId) : undefined;
  const clock = useProjectClock(issue?.age, stage, workflow);
  if (!collapsed || !issue || clock.updatesOff) return null;
  return (
    <FollowUpCaption
      reading={{ label: clock.nextLabel, ...(clock.color ? { color: clock.color } : {}) }}
    />
  );
}
